<template>
  <div class="documentMenu">
    <v-img class="background-display">
    <Navbar />
    <v-container class="my-2" fluid>
      <v-alert v-model="alertAxios" border="left" close-text="Close Alert" dismissible dense outlined type="error">
        Ha ocurrido un error!
      </v-alert>
      <v-container>
      <v-toolbar dark color="#00b2bb">
          <p class="ma-2 title font-weight-thin">Seleccione un Trámite</p>
        </v-toolbar>
        <v-row dense wrap>
          <v-col
            v-for="(lista, index) in formData"
            :key="index"
            xs="12" md="4" sm="6" lg="4"
            class="d-flex"
          >
          <v-card class="d-flex flex-column mb-5" flat>
            <v-avatar
                class="ma-3"
                size="auto"
                tile
              >
              <v-img
                v-if="lista.urlImagen" :src="lista.urlImagen"
                height="200px"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              >
              </v-img>
              <v-img
                v-else src="../../assets/logoNotariaAzul.png"
                height="200px"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              >
              </v-img>
              </v-avatar>
              <v-card-text class="font-weight-regular black--text subtitle-1" v-text="lista.name"></v-card-text>
              <v-card-text class="font-weight-regular black--text text-justify" color="black"
              v-text="lista.description"></v-card-text>
              <v-spacer></v-spacer>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn rounded dark
                color="primary" class="font-weight-light white--text mb-5" @click="goToDocument(lista._id, lista.name)">Realizar Trámite
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        </v-container>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    </v-img>
  </div>
</template>

<style>
.title-size {
  font-size: 2em;
}
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
.complete-text {
  word-break: normal;
}
</style>
<script>
import Navbar from '@/components/Navbar.vue'
import api from '@/plugins/api'
import store from '@/store/index.js'

export default {
  name: 'DocumentMenu',
  components: {
    Navbar
  },
  data () {
    return {
      tramites: [],
      formData: [],
      overlay: false,
      alertAxios: false,
      signPassport: store.state.user.attributes['custom:passport'],
      userPassport: false
    }
  },
  mounted () {
    this.getTodos()
    this.overlay = !this.overlay
    this.passportExist()
    /* this.formData = select1 */
  },
  /* watch: {
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 3500)
    }
  }, */
  methods: {
    async getTodos () {
      try {
        const response = await api.get('disponibles')
        /* console.log(response) */
        // ordena la lista de tramites
        response.data.sort(function (a, b) {
          return a.name.localeCompare(b.name)
        })
        // filtra el tramite que no deberia ser mostrado para usuario con pasaporte
        if (this.userPassport === true) {
          const index = response.data.filter(x => x.showOnlyRut !== true)
          response.data.splice(index, 1)
          this.formData = index
        } else {
          this.formData = response.data
        }
        /* console.log(response.data) */
        this.overlay = false
        /* this.tramites = response.data */
      } catch (error) {
        this.alertAxios = true
        this.overlay = false
        console.log('Error al recibir el endPoint' + error)
      }
    },
    goToDocument (id, name) {
      localStorage.setItem('name_doc', JSON.stringify(name))
      this.$router.push(`/NewDocument/Document/${id}`)
    },
    // valida si el usuario registrado entro con pasaporte
    passportExist () {
      if (this.signPassport) {
        this.userPassport = true
      }
    }
  }
}
</script>
